import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  BaseText,
  Heading,
  ContentDisplay,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { ContentDisplayLoader } from '@/modules/trade/components/ContentDisplayLoader';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  PortfolioStrategy,
  PortfolioRiskProfile
} from '@/modules/wealth/services/portfolio';
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';

interface Props {
  strategy?: PortfolioStrategy;
  riskProfile?: PortfolioRiskProfile;
  isLoading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutStrategy',
  props: {
    strategy: null,
    riskProfile: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



const riskProfileHref = computed(() => {
  const { domain } = getDomainAndPlatform();

  return `/onboarding/${domain}/desktop/suitability/user-profile`;
});

return { __sfc: true,riskProfileHref, BaseText, Heading, ContentDisplay, SkeletonLoader, ContentDisplayLoader, NebraskaColors }
}

})